import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "文档下载", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"2rem"} }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://tc.talentedsoft.com:58108/static/docs/%E5%A4%A9%E8%81%AA%E8%AF%AD%E9%9F%B3%E5%BC%80%E6%94%BE%E5%B9%B3%E5%8F%B0%E6%8E%A5%E5%8F%A3%E5%8D%8F%E8%AE%AE-V6.0.pdf",
    download: "天聪语音开放平台接口协议-V6.0.pdf",
    style: {"text-decoration":"none"}
  }, " 天聪语音开放平台接口协议-V6.0.pdf ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
}